<div class="grid lg:grid-cols-[1fr_1.3fr] h-screen overflow-hidden bg-white font-[Montserrat] max-w-[1280px] mx-auto">
  <!-- LEFT PANE -->
  <div class="flex flex-col justify-center gap-6 px-12 lg:px-16">
    <p-image class="w-24 h-auto" src="assets/images/logo.png" alt="NITI"></p-image>

    <div>
      <h2 class="font-bold text-2xl text-[var(--color-text-primary)] mb-2">Reset Password</h2>
      <p class="text-base text-[var(--color-text-primary)]">Reset your password securely and quickly.</p>
    </div>

    <form class="flex flex-col gap-1 mt-2" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
      <label class="block text-xs font-bold text-[var(--color-text-primary)] mb-1" for="password">New Password</label>
      <p-password
        inputId="password"
        formControlName="password"
        [feedback]="false"
        [toggleMask]="true"
        [placeholder]="'Enter your password'"
        [inputStyleClass]="'custom-password-input w-full rounded-lg border border-gray-200 pl-4 pr-9 py-4 font-[Montserrat] font-normal text-[14px] leading-[100%] tracking-[-0.01em] text-[var(--color-text-primary)] outline-none focus:border-[var(--color-primary-500)] focus:ring-2 focus:ring-[rgba(239,71,111,0.15)]'"
      ></p-password>
      @if (password?.errors?.['required'] && password?.touched) {
      <div class="text-red-500 text-xs mt-1">
        Password is required
      </div>
      }
      <label class="block text-xs font-bold text-[var(--color-text-primary)] mt-2 mb-1" for="confirmPassword">Re-enter New Password</label>
      <p-password
        inputId="confirmPassword"
        formControlName="confirmPassword"
        [feedback]="false"
        [toggleMask]="true"
        [placeholder]="'Enter your password'"
        [inputStyleClass]="'custom-password-input w-full rounded-lg border border-gray-200 pl-4 pr-9 py-4 font-[Montserrat] font-normal text-[14px] leading-[100%] tracking-[-0.01em] text-[var(--color-text-primary)] outline-none focus:border-[var(--color-primary-500)] focus:ring-2 focus:ring-[rgba(239,71,111,0.15)]'"
      ></p-password>
      @if (confirmPassword?.errors?.['required'] && confirmPassword?.touched) {
      <div class="text-red-500 text-xs mt-1">
        Confirm password is required
      </div>
      }
      <p-button 
        type="submit" 
        label="Reset Password" 
        icon="pi pi-angle-right" 
        iconPos="right" 
        [disabled]="resetPasswordForm.invalid || isLoading"
        styleClass="w-full rounded-lg pt-[14px] pb-4 px-4 border-l-[3px] border-l-black/15 !bg-[var(--color-table-header)] hover:!bg-[var(--color-primary-red)] !text-white !border-none cursor-pointer mt-3 disabled:opacity-50 disabled:cursor-not-allowed"
      ></p-button>
    </form>
     
     <div class="text-center mt-4">
       <span class="text-sm text-[var(--color-text-primary)]">Return to </span>
       <a routerLink="/sign-in" class="text-sm font-bold underline text-[var(--color-text-primary)] hover:text-[var(--color-primary-red)]">Log in</a>
     </div>
  </div>

  <!-- RIGHT PANE -->
  <div class="hidden lg:flex h-full items-center justify-center bg-[url('assets/images/signin-bg.png')] bg-no-repeat bg-cover bg-center rounded-[30px] p-6 overflow-hidden">
    <div class="w-full max-w-[820px] text-center px-10">
      <p-image class="w-full mb-6" src="assets/images/signin-image.png" alt="Application preview"></p-image>
      <h3 class="font-bold text-[34.16px] leading-[1] text-center mb-3 max-w-[820px] mx-auto">
        Securely manage and access all your documents
      </h3>
      <p class="text-sm text-[#4b5563] mx-auto max-w-[820px]">
        Centralize your documents for improved organization, enhanced security, and seamless collaboration across teams
      </p>
    </div>
  </div>
</div>

<!-- Toast Messages -->
<p-toast position="top-right"></p-toast>